export default __webpack_public_path__ + "static/media/gmail.6770ed08.png";